import {
  getProjectsLogic,
  getProjectLogic,
  getProjectIpfsLogic,
  updateBondsLogic,
  patchProjectLogic,
  updateProjectLogic,
  updateCoordinatesLogic,
  removeContactLogic,
  deleteFileIpfsLogic,
  getProjectImagesLogic,
  deleteFileImageLogic,
  getProjectTransactionsLogic,
  getSdgsByProjectLogic,
  getImpactsByProjectLogic,
  deleteImpactLogic,
  deleteSdgByProjectLogic,
  createImpactLogic,
   getProjectBlockchainTransactionsLogic
} from "./Projects.logic";
import {
  saveCountProjects,
  saveListProjects,
  saveSelectedProject,
  saveIpfs,
  saveImages,
  saveTransactions,
  saveSdgs,
  saveImpacts,
   saveBlockchainTransactions
} from "../Infrastructure/Projects.store";

export async function getProjects(params) {
  const { count, resources: projects } = await getProjectsLogic(params);
  saveListProjects(projects);
  saveCountProjects(count);
}

export async function getProject(id) {
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}

export async function getProjectIpfs(id) {
  const ipfs = await getProjectIpfsLogic(id);
  saveIpfs(ipfs);
}

export async function updateBonds(id, params) {
  await updateBondsLogic(id, params);
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}
export async function updateProject(id, params) {
  await updateProjectLogic(id, params);
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}

export async function updateCoordinates(id, params) {
  await updateCoordinatesLogic(id, params);
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}

export async function patchProject(id, params) {
  await patchProjectLogic(id, params);
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}

// export async function removeContact(id) {
//   await removeContactLogic(id);
//   deleteSelectedremoveContact(id);
// }
export async function removeContact(id, params) {
  await removeContactLogic(id, params);
  const project = await getProjectLogic(id);
  saveSelectedProject(project);
}
export async function deleteFileIpfs(id, params) {
  await deleteFileIpfsLogic(id, params);
  const project = await getProjectIpfsLogic(id);
  saveIpfs(project);
}
export async function getProjectImages(id, params = {}) {
  const response = await getProjectImagesLogic(id, params);
  saveImages(response);
  return response;
}
export async function deleteFileImage(projectId, imageId) {
  await deleteFileImageLogic(projectId, imageId);
  const updatedImages = await getProjectImagesLogic(projectId);
  saveImages(updatedImages);
  return true;
}
export async function getProjectTransactions(id, state, type) {
  const transactions = await getProjectTransactionsLogic(id, state, type);
  saveTransactions(transactions);
}

export async function getSdgsByProject(id) {
  const sdgs = await getSdgsByProjectLogic(id);
  saveSdgs(sdgs);
}

export async function getImpactsByProject(id) {
  const impacts = await getImpactsByProjectLogic(id);
  saveImpacts(impacts);
}

export async function deleteImpact(id, params) {
  await deleteImpactLogic(id, params);
  const impacts = await getImpactsByProjectLogic(id);
  saveImpacts(impacts);
}

export async function deleteSdgByProject(id, id_sdg) {
  await deleteSdgByProjectLogic(id, id_sdg);
  const sdgs = await getSdgsByProjectLogic(id);
  saveSdgs(sdgs);
}

export async function createImpact(id, params) {
  const impact = await createImpactLogic(id, params);
}
export async function getProjectBlockchainTransactions(id) {
  const projects = await getProjectBlockchainTransactionsLogic(id);
    saveBlockchainTransactions(projects);

}